import { useQuery } from "@tanstack/react-query";

import { ALL_USERS_CACHE_KEY } from "./keys";

import { isMockEnabled, simulateDelay } from "@/mock/config";
import { getUsersMock } from "@/mock/handlers/user";
import { Response } from "@/types/pagination";
import { User } from "@/types/user";

import { api } from "@/lib/api-client";

export const useGetAllUsers = () => {
  return useQuery({
    queryKey: ALL_USERS_CACHE_KEY,
    queryFn: async () => {
      if (isMockEnabled()) {
        await simulateDelay();
        return getUsersMock();
      }

      const { data } = await api
        .get("organizations/users")
        .json<Response<User[]>>();

      return data;
    },
  });
};
